import { JsonSchemaValidator } from "@common/json-schema-validator";
import { identityAccountId } from "../../schema";
import { AccountMethods } from "../../const";
import { AccountIdentity, IdentityAccountId } from "../../interface";
import { BaseVO } from "../base.vo";

export class KeycloakAccountJwtVO extends BaseVO<KeycloakAccountJwtVORaw> {
  private static validation = JsonSchemaValidator.compile(
    KeycloakAccountJwtVO.validationSchema()
  );

  constructor(value: KeycloakAccountJwtVORaw) {
    super(JsonSchemaValidator.assert(KeycloakAccountJwtVO.validation, value));
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["id", "method"],
      properties: {
        id: identityAccountId,
        method: {
          enum: [AccountMethods.Keycloak]
        }
      }
    };
  }
}

interface KeycloakAccountJwtVORaw {
  id: IdentityAccountId;
  identity: AccountIdentity;
  method: typeof AccountMethods.Keycloak;
}
